// extracted by mini-css-extract-plugin
export var orderSummary = "_so-0";
export var showMoreLessButton = "_so-1";